import { useNavigate } from "@tanstack/react-router";
import { IconArrowRight } from "@tabler/icons-react";
import { Button, Card, Group, Stack, Text, ThemeIcon } from "@/components/ui";
import type { SolicitudDetalle } from "@/lib/types";
import { calcularSiguientePaso } from "@/features/solicitud-detalle/hooks/use-siguiente-paso";

/**
 * Card destacada en la sidebar · sugiere el "siguiente paso" según el
 * estado actual. Si la solicitud está en un estado donde no hay
 * siguiente paso obvio (Autorizada, terminal, etc.), no renderiza nada.
 */
export function SiguientePasoCTA({ sol }: { sol: SolicitudDetalle }) {
  const navigate = useNavigate();
  const paso = calcularSiguientePaso(sol);
  if (!paso) return null;
  return (
    <Card
      padding="md"
      style={{
        backgroundColor: "light-dark(var(--color-multiva-50), color-mix(in srgb, var(--color-multiva-600) 12%, transparent))",
        borderColor: "var(--color-multiva-300)",
      }}
    >
      <Stack gap="xs">
        <Group gap="xs">
          <ThemeIcon variant="filled" color="multiva" radius="md" size="md">
            <IconArrowRight size={14} />
          </ThemeIcon>
          <Text fw={600} size="sm">Siguiente paso</Text>
        </Group>
        <Text size="xs" c="dimmed">Continúa el flujo de la solicitud.</Text>
        <Button
          size="sm"
          rightSection={<IconArrowRight size={14} />}
          onClick={() =>
            navigate({
              to: paso.to as never,
              params: { id: sol.id } as never,
              replace: true,
            })
          }
        >
          {paso.label}
        </Button>
      </Stack>
    </Card>
  );
}
